import React, {useCallback, useContext, useMemo, useEffect} from "react";

import {Conjunto} from "../../../../Components/Conjunto";

import {Button, Col, Empty, Form, Grid, Input, Row, Select, Tag, Tooltip,} from "antd";
import {ResponsiveAntdTable} from "../../../../Components/ResponsiveAntdTable";
import {TypeViagem} from "../../../../Models/Domain/Viagem/Viagem";
import {useForm, useWatch} from "antd/lib/form/Form";
import {EnumStatusDaViagem, TypeStatusDaViagem} from "../../../../Models/Domain/Viagem/StatusDaViagem";
import {SessaoARContext} from "../../../Contexts/SessaoContext";
import {ParametrosDaSessaoARContext, ParametrosDaSessaoDoResponsavel} from "../../../Views/Sistema/ParametrosDaSessao";
import {EnumTipoUsuario} from "../../../../Models/Domain/AreaRestrita/Sessao";
import {Formatacoes} from "../../../../Utils/Formatacao";
import {TypeDestino} from "../../../../Models/Domain/Viagem/Destino";

import {AlunoServiceH, useListarInscricoes} from "../../../../Services/Domain/Pessoa/AlunoService";
import {StatusDaViagemServiceH} from "../../../../Services/Domain/Viagem/StatusDaViagemService";
import {_TypeInscricaoDoAlunoNaViagemSemRecursao, TypeInscricaoDoAlunoNaViagem} from "../../../../Models/Domain/Viagem/InscricaoDoAlunoNaViagem";
import {EnumStatusDaInscricaoDoAlunoNaViagem} from "../../../../Models/Domain/Viagem/Enum";
import { Ordenar } from "../../../../Utils/Ordenacao";
import { Link } from "react-router-dom";
import { useListarInscricoesResponsavelSessao } from "../../../../Services/Domain/Viagem/InscricaoService";
import Utilitario from "../../../../Utils/Utilitario";
import { extractorNomePessoa } from "@/Models/Pessoa/Pessoa";
import InputDate from "@/Components/Base/Input/InputDate";
// import { extractorNomePessoa } from "../../../../Models/Domain/Pessoa/Aluno";

export const ListagemDeViagensDoResponsavel: React.FC<{
    obterAcoes?: (inscricao: TypeInscricaoDoAlunoNaViagem) => React.ReactNode[]
}> = (props) => {
    const tamanhoDaTela = Grid.useBreakpoint();

    const SessaoAR = useContext(SessaoARContext);
    const sessaoValida = SessaoAR?.sessao?.tipoDeUsuario === EnumTipoUsuario.Responsavel;
    interface IFiltro {
        destino?: TypeViagem["destino"],
        titulo?: TypeViagem["titulo"],
        de?: TypeViagem["inicio"],
        ate?: TypeViagem["fim"],
        statusDaViagem?: TypeViagem["status"],
        statusDaInscricao?: TypeInscricaoDoAlunoNaViagem["status"],
        ativo?: TypeViagem["ativo"],
    }

    const [form] = useForm<IFiltro>();
    const filtro = useWatch([], form);

    const statusDisponiveis =  StatusDaViagemServiceH.useGetPossiveisStatusDaViagem();
    const {
        data : inscricoes,
        isSuccess : inscricoesQueryIsSucess,
        isLoading,
    } = useListarInscricoesResponsavelSessao({
        enabled: sessaoValida
    });

    useEffect(() => {
        if(inscricoesQueryIsSucess){
            inscricoes.sort((a, b) => -1 * Ordenar.Data(a.dataDeInscricao, b.dataDeInscricao))
        }
    }, [inscricoesQueryIsSucess])

    const destinos = useMemo(() => Utilitario.groupBy(inscricoes ?? [], i => i.viagem!.destino!.codigo!).map(m => m.data.find(f => true)!.viagem!.destino!), [inscricoes]);
    const status = useMemo(() => Utilitario.groupBy(inscricoes ?? [], i => i.viagem!.status!.codigo!).map(m => m.data.find(f => true)!.viagem!.status!), [inscricoes]);

    const filterPipe = useCallback((item: TypeInscricaoDoAlunoNaViagem): boolean => {
        if (filtro == undefined) return true;

        const fDe = (Formatacoes.paraData(filtro.de));
        const fAte = (Formatacoes.paraData(filtro.ate));

        const fInicio = (Formatacoes.paraData(item.viagem?.inicio));
        const fFim = (Formatacoes.paraData(item.viagem?.fim));

        return (
            ((filtro.destino?.codigo) === undefined || (item.viagem?.destino?.codigo === filtro.destino?.codigo)) &&
            ((filtro.titulo === undefined) || (item.viagem?.titulo !== undefined && item.viagem?.titulo?.toLowerCase().includes(filtro.titulo.toLowerCase()))) &&
            ((fDe === undefined) || (fInicio !== undefined && fInicio >= fDe)) &&
            ((fAte === undefined) || (fFim !== undefined && fFim <= fAte)) &&
            ((filtro.statusDaViagem === undefined || filtro.statusDaViagem.codigo === undefined) || (item.viagem?.status?.codigo === filtro.statusDaViagem?.codigo)) &&
            ((filtro.statusDaInscricao === undefined ) || (item.status === filtro.statusDaInscricao)) &&
            true
        )

    }, [filtro]);

    if (sessaoValida === false) return <Empty description="A sessão atual da Área Restrita não é uma sessão do tipo responsável" />;

    return <React.Fragment>
        <Form<IFiltro> form={form} layout='vertical' autoComplete='off'>
            <Row gutter={16}>

                <Col xs={24} md={24} xl={6}>
                    <Form.Item<IFiltro> name={["titulo"]} label="Título">
                        <Input placeholder="Todos" />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={4}>
                    <Form.Item<IFiltro> name={["statusDaInscricao"]} label="Status da inscrição">
                        <Select
                            allowClear
                            placeholder={"Todos"}
                            options={[
                                {value: EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO, label: "Aguardando inscricao"},
                                {value: EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO, label: "Aguardando pagamento"},
                                {value: EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO, label: "Inscrito e pago"},
                                {value: EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO, label: "Cancelado"},
                            ]}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={4}>
                    <Form.Item<IFiltro> name={["statusDaViagem", "codigo"]} label="Status da viagem">
                        <Select
                            allowClear
                            placeholder={"Todos"}
                            options={status.map((item) => ({value: item.codigo, label: item.descricao}))}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8} xl={4}>
                    <Form.Item<IFiltro> name={["destino", "codigo"]} label="Destino">
                        <Select
                            allowClear
                            placeholder={"Todos"}
                            options={destinos.map((item) => ({value: item.codigo, label: item.nome}))}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8} xl={3}>
                    <Form.Item<IFiltro> name={["de"]} label="De">
                        <InputDate style={{width: "100%"}} placeholder="Todos" />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8} xl={3}>
                    <Form.Item<IFiltro> name={["ate"]} label="Até">
                        <InputDate style={{width: "100%"}} placeholder="Todos" />
                    </Form.Item>
                </Col>

            </Row>
        </Form>

        <Row>
            <Col xs={24}>
                <ResponsiveAntdTable<TypeInscricaoDoAlunoNaViagem, _TypeInscricaoDoAlunoNaViagemSemRecursao>
                    bordered
                    rowKey={(k) => k.codigo!}
                    locale={{emptyText: 'Nenhuma viagem encontrada.'}}
                    loading={isLoading}
                    dataSource={(inscricoes ?? []).filter(f => filterPipe(f))}
                    addTitleOn="lg"
                    columns={[
                        {
                            title: "Aluno",
                            dataIndex: ["aluno"],
                            breakpoints: { xs : 12, sm : 12, md : 8, lg : 4, xl : 4, xxl : 4 },
                            key: "inscricao-aluno-nome",
                            render : (aluno) => extractorNomePessoa(aluno.pessoa),
                            sorter: (a, b) => Ordenar.String(extractorNomePessoa(a.aluno!.pessoa!), extractorNomePessoa(b.aluno!.pessoa!))
                        },
                        {
                            title: "Viagem",
                            dataIndex: ["viagem", "titulo"],
                            breakpoints: { xs : 12, sm : 12, md : 8, lg : 5, xl : 5, xxl : 5 },
                            key: "inscricao-viagem-titulo",
                            sorter: (a, b) => Ordenar.String(a?.viagem?.titulo, b?.viagem?.titulo),
                        },
                        {
                            title: "Prazo de inscrição",
                            dataIndex: ["viagem", "prazoDeInscricao"],
                            breakpoints: { xs : 12, sm : 12, md : 8, lg : 3, xl : 3, xxl : 3 },
                            key: "viagem-prazo-inscricao",
                            sorter: (a, b) => Ordenar.Data(a?.viagem?.prazoDeInscricao, b?.viagem?.prazoDeInscricao),
                            render: (val) => {
                                const prazo = Formatacoes.paraData(val);
                                if(prazo == undefined) return "N/A";

                                if (prazo < new Date()) return (
                                    <Tooltip placement="bottomLeft" title="O prazo já encerrou">
                                        <Tag style={{width: "fit-content"}} color="error">{prazo.toLocaleDateString()}</Tag>
                                    </Tooltip> 
                                )

                                return prazo.toLocaleDateString()
                            },
                        },
                        // {
                        //     title: "Datas",
                        //     breakpoints: { xs : 12, sm : 12, md : 8, lg : 8, xl : 6, xxl : 2 },
                        //     key: "inscricao-viagem-datas",
                        //     render: (_, item) => {
                        //         let inicio = Formatacoes.paraData(item?.viagem?.inicio)
                        //         let fim = Formatacoes.paraData(item?.viagem?.fim)
                        //         return <>{inicio?.toLocaleDateString() ?? "N/A"} : {fim?.toLocaleDateString() ?? "N/A"}</>
                        //     },
                        // },
                        {
                            title: "Data da inscrição",
                            dataIndex: ["dataDeInscricao"],
                            breakpoints: { xs : 12, sm : 12, md : 8, lg : 3, xl : 3, xxl : 3 },
                            key: "inscricao-data-inscricao",
                            render: (v) => Formatacoes.paraData(v)?.toLocaleDateString(),
                            sorter: (a, b, order) => Ordenar.Data(a?.dataDeInscricao, b?.dataDeInscricao)
                        },
                        {
                            title: "Status",
                            dataIndex: ["status"],
                            breakpoints: { xs : 12, sm : 12, md : 8, lg : 3, xl : 3, xxl : 3 },
                            key: "inscricao-status",
                            render: (v: EnumStatusDaInscricaoDoAlunoNaViagem) => {
                                if (v == EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_INSCRICAO) {
                                    return <Tag style={{width: "min-content" }} color="default">Aguardando inscrição</Tag>
                                }

                                if (v == EnumStatusDaInscricaoDoAlunoNaViagem.AGUARDANDO_PAGAMENTO) {
                                    return <Tag style={{width: "min-content" }} color="blue">Aguardando pagamento</Tag>
                                }

                                if (v == EnumStatusDaInscricaoDoAlunoNaViagem.INSCRITO_E_PAGO) {
                                    return <Tag style={{width: "min-content"}} color="green">Inscrito e pago</Tag>
                                }

                                if (v == EnumStatusDaInscricaoDoAlunoNaViagem.CANCELADO) {
                                    return <Tag style={{width: "min-content"}} color="red">Cancelado</Tag>
                                }

                                return <Tag>Ocorreu um erro</Tag>
                            },
                            sorter: (a, b) => Ordenar.Numero(a?.status, b?.status),
                        },
                        {
                            title: "Situação da viagem",
                            dataIndex: ["viagem", "status"],
                            breakpoints: { xs : 12, sm : 12, md : 8, lg : 3, xl : 3, xxl : 3 },
                            key: "inscricao-viagem-status",
                            render: (v: TypeStatusDaViagem) => {

                                if (v.codigo == EnumStatusDaViagem.EM_ANDAMENTO) {
                                    return <Tag style={{width: "min-content"}} color="green">{v.descricao}</Tag>
                                }

                                if (v.codigo == EnumStatusDaViagem.ENCERRADA) {
                                    return <Tag style={{width: "min-content"}} color="blue">{v.descricao}</Tag>
                                }

                                if (v.codigo == EnumStatusDaViagem.CANCELADA) {
                                    return <Tag style={{width: "min-content"}} color="red">{v.descricao}</Tag>
                                }

                                return v.descricao
                            },
                            sorter: (a, b) => Ordenar.String(a?.viagem?.status?.descricao, b?.viagem?.status?.descricao),
                        },
                        {
                            title: "Ações",
                            key: "inscricao-acoes",
                            noResponsiveTitle: true,
                            breakpoints: { xs : 24, sm : 24, md : 24, lg : 3, xl : 3, xxl : 3 },
                            render: (_, item) => {
                                return <Conjunto
                                    style={{justifyContent: tamanhoDaTela.sm ? "unset" : "center", display: "flex", flexWrap: 'wrap'}}
                                    itens={props.obterAcoes?.(item)}
                                />
                            }
                        },

                    ]}
                />
            </Col>
        </Row>

    </React.Fragment >

}
